/*
  LIOR - the collection banner in the style of iOS 27 (sections/page-banner.liquid,
  styles in assets/lior-ios-banner-hero.css)

    - "עוד" / "פחות": a real button under the description. The text opens and
      closes on a spring (height), can be reversed mid-way, and the button only
      appears when the text is longer than two lines.
    - the capsule row: a soft edge on whichever side still has more to scroll to
    - light under the finger on the capsules
  The title's entrance is CSS only. Everything here is skipped or instant under
  prefers-reduced-motion, and the page reads in full without this file.
*/
(function () {
  'use strict';

  var W = window;
  var D = document;
  /* the theme editor can run this file again when it reloads the section */
  if (W.__liorIosBanner) {
    W.__liorIosBanner();
    return;
  }
  var mqReduce = W.matchMedia('(prefers-reduced-motion: reduce)');
  /* damping 0.86, response 0.42: a hint of give at the end, nothing more */
  var SPRING = 'linear(0, 0.0364, 0.1203, 0.2338, 0.349, 0.4609, 0.5636, 0.6586, 0.7353, 0.799, 0.8507, 0.8918, 0.9252, 0.9492, 0.9671, 0.9801, 0.9897, 0.9959, 0.9999, 1.0024, 1.0037, 1.0043, 1.0044, 1.0041, 1.0037, 1.0032, 1.0027, 1.0022, 1.0018, 1.0014, 1.0011, 1.0008, 1)';
  var EASE = W.CSS && CSS.supports && CSS.supports('transition-timing-function', 'linear(0, 1)') ? SPRING : 'cubic-bezier(0.32, 0.72, 0, 1)';

  function reduce() { return mqReduce.matches; }

  function toggle(el, cls, on) {
    if (el.classList.contains(cls) !== on) el.classList.toggle(cls, on);
  }

  var mounted = [];

  function mount(root) {
    if (root.__lib) return;
    root.__lib = true;
    root.classList.add('lib-js');
    var api = { root: root, layout: function () {} };

    /* ---------------- "עוד" / "פחות" ---------------- */
    var desc = root.querySelector('[data-lib-desc]');
    var btn = root.querySelector('[data-lib-more]');
    var label = btn && btn.querySelector('.lib-more-t');
    var open = false;
    var anim = null;

    function measure() {
      if (!desc || !btn || open || anim) return;
      var clamped = desc.scrollHeight > desc.clientHeight + 2;
      toggle(desc, 'is-clamped', clamped);
      if (btn.hidden === clamped) btn.hidden = !clamped;
    }

    function setOpen(next) {
      if (!desc || next === open) return;
      var from = desc.getBoundingClientRect().height;
      if (anim) {
        anim.cancel();
        anim = null;
      }
      open = next;
      toggle(desc, 'is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? 'פחות' : 'עוד';
      toggle(desc, 'is-moving', true);
      var to = desc.scrollHeight;
      if (!open) {
        /* the closed height is what the clamp leaves */
        toggle(desc, 'is-moving', false);
        to = desc.getBoundingClientRect().height;
        toggle(desc, 'is-moving', true);
      }
      if (reduce() || !desc.animate || Math.abs(to - from) < 1) {
        toggle(desc, 'is-moving', false);
        return;
      }
      anim = desc.animate([{ height: from + 'px' }, { height: to + 'px' }], {
        duration: open ? 640 : 520,
        easing: EASE
      });
      var mine = anim;
      mine.onfinish = function () {
        if (anim !== mine) return;
        anim = null;
        toggle(desc, 'is-moving', false);
      };
    }

    if (desc && btn) {
      btn.addEventListener('click', function () { setOpen(!open); });
      measure();
      api.layout = measure;
      if (D.fonts && D.fonts.ready) D.fonts.ready.then(measure);
    }

    /* ---------------- The capsule row: soft edges where there is more ---------------- */
    var row = root.querySelector('[data-lib-chips]');
    var edgeRaf = 0;
    function gutter() {
      if (!row) return;
      var g = parseFloat(W.getComputedStyle(row).paddingRight) || 0;
      var v = g > 0 ? g.toFixed(1) + 'px' : '';
      if (row.style.getPropertyValue('--lib-gutter') !== v) {
        if (v) row.style.setProperty('--lib-gutter', v);
        else row.style.removeProperty('--lib-gutter');
      }
    }
    function edges() {
      edgeRaf = 0;
      if (!row) return;
      var max = row.scrollWidth - row.clientWidth;
      var x = Math.abs(row.scrollLeft);
      toggle(row, 'is-s', max > 1 && x > 2);
      toggle(row, 'is-e', max > 1 && x < max - 2);
    }
    if (row) {
      row.addEventListener('scroll', function () {
        if (!edgeRaf) edgeRaf = W.requestAnimationFrame(edges);
      }, { passive: true });
      gutter();
      edges();
      var prev = api.layout;
      api.layout = function () { prev(); gutter(); edges(); };
    }

    /* ---------------- Light under the finger ---------------- */
    var pressed = null;
    function release() {
      if (pressed) pressed.classList.remove('is-pressed');
      pressed = null;
    }
    root.addEventListener('pointerdown', function (e) {
      var c = e.target.closest && e.target.closest('.lib-chip');
      if (!c || (e.button && e.button !== 0)) return;
      var r = c.getBoundingClientRect();
      c.style.setProperty('--lib-px', (e.clientX - r.left).toFixed(1) + 'px');
      c.style.setProperty('--lib-py', (e.clientY - r.top).toFixed(1) + 'px');
      release();
      pressed = c;
      c.classList.add('is-pressed');
    });
    root.addEventListener('pointermove', function (e) {
      if (!pressed) return;
      var r = pressed.getBoundingClientRect();
      if (e.clientX < r.left - 20 || e.clientX > r.right + 20 || e.clientY < r.top - 20 || e.clientY > r.bottom + 20) return release();
      pressed.style.setProperty('--lib-px', (e.clientX - r.left).toFixed(1) + 'px');
      pressed.style.setProperty('--lib-py', (e.clientY - r.top).toFixed(1) + 'px');
    }, { passive: true });
    W.addEventListener('pointerup', release, true);
    W.addEventListener('pointercancel', release, true);
    /* a sideways swipe on the row is a scroll, not a press */
    if (row) row.addEventListener('scroll', release, { passive: true });

    mounted.push(api);
  }

  var rt = 0;
  W.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      mounted = mounted.filter(function (m) { return m.root.isConnected; });
      mounted.forEach(function (m) { m.layout(); });
    }, 120);
  });

  function scan() {
    var roots = D.querySelectorAll('[data-lib]');
    for (var i = 0; i < roots.length; i++) mount(roots[i]);
  }

  W.__liorIosBanner = scan;
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  D.addEventListener('shopify:section:load', scan);
})();
